import { ReactComponent as VKColorLight } from 'fym-shared/src/music-services/assets/images/vk-color-light.svg';
import { ReactComponent as VKColorDark } from 'fym-shared/src/music-services/assets/images/vk-color-dark.svg';
import { ReactComponent as VKColorLightPadding } from 'fym-shared/src/music-services/assets/images/vk-color-light-padding.svg';
import { ReactComponent as VKColorDarkPadding } from 'fym-shared/src/music-services/assets/images/vk-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const vkImages: MusicServiceImages = {
  logoColor: {
    light: VKColorLight,
    dark: VKColorDark,
  },
  logoColorPadding: {
    light: VKColorLightPadding,
    dark: VKColorDarkPadding,
  },
};
